import React from 'react'
import classNames from 'classnames'
import ImageResolutions from '@toasttab/shared/src/components/atoms/Image/ImageResolutions'
import { FiftyDemoFormProps } from './FiftyDemoForm.d'
import MainForm from '../Molecules/MainForm'

const FiftyDemoForm = ({
  cssClasses,
  imagePosition,
  imageResolutions,
  scrollTrackingSectionName,
  heading,
  description,
  privacyStatement,
  variation = 'default',
  region = 'US',
  uniqueId
}: FiftyDemoFormProps) => {
  const fields = []
  fields.push({
    title: 'First and last name*',
    fieldLabel: 'First and last name*',
    marketoFieldName: 'mkoFullName',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'mkoFullName',
    fieldType: 'Text',
    fieldOptions: [],
    fieldDependentId: '',
    __typename: 'ContentfulMdsFormField'
  })
  fields.push({
    title: 'Phone*',
    fieldLabel: 'Phone*',
    marketoFieldName: 'Phone',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'phone',
    fieldType: 'Phone',
    fieldOptions: [],
    fieldDependentId: '',
    __typename: 'ContentfulMdsFormField'
  })
  fields.push({
    title: 'Restaurant Name*',
    fieldLabel: 'Restaurant Name*',
    marketoFieldName: 'Company',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'company',
    fieldType: 'Text',
    fieldOptions: [],
    fieldDependentId: '',
    __typename: 'ContentfulMdsFormField'
  })
  fields.push({
    title: 'Email*',
    fieldLabel: 'Email*',
    marketoFieldName: 'Email',
    isRequired: true,
    fieldInputNameMarketoRestApi: 'email',
    fieldType: 'Email',
    fieldOptions: [],
    fieldDependentId: '',
    __typename: 'ContentfulMdsFormField'
  })
  if (region === 'US') {
    fields.push({
      title: 'Primary restaurant location zip code*',
      fieldLabel: 'Primary restaurant location zip code*',
      marketoFieldName: 'postalCode',
      isRequired: true,
      fieldInputNameMarketoRestApi: 'postalCode',
      fieldType: 'Text',
      fieldOptions: [],
      fieldDependentId: '',
      __typename: 'ContentfulMdsFormField'
    })
    fields.push({
      title: 'Which best describes you?*',
      fieldLabel: 'Which best describes you?*',
      marketoFieldName: 'toastType',
      isRequired: true,
      fieldInputNameMarketoRestApi: 'toastType',
      fieldType: 'Select (Dropdown)',
      fieldOptions: [
        {
          key: "I'm interested in buying Toast",
          value: "I'm interested in buying Toast"
        },
        {
          key: "I'm already a Toast customer",
          value: "I'm already a Toast customer"
        },
        { key: "I'm a restaurant guest", value: "I'm a restaurant guest" }
      ],
      fieldDependentId: '',
      __typename: 'ContentfulMdsFormField'
    })
  }
  if (region !== 'US') {
    let defaultValue = ''
    if (region === 'CA') {
      defaultValue = 'Canada'
    } else if (region === 'IE') {
      defaultValue = 'Ireland'
    } else if (region === 'UK') {
      defaultValue = 'United Kingdom'
    }
    fields.push({
      title: 'Select Country*',
      fieldLabel: 'Select Country*',
      marketoFieldName: 'country',
      isRequired: false,
      fieldInputNameMarketoRestApi: 'country',
      fieldType: 'Select (Dropdown)',
      fieldOptions: [
        { key: 'United States', value: 'United States' },
        { key: 'Canada', value: 'Canada' },
        { key: 'Ireland', value: 'Ireland' },
        { key: 'United Kingdom', value: 'United Kingdom' }
      ],
      defaultValue: defaultValue,
      fieldDependentId: '',
      __typename: 'ContentfulMdsFormField'
    })
    fields.push({
      title: 'Which best describes you?*',
      fieldLabel: 'Which best describes you?*',
      marketoFieldName: 'toastType',
      isRequired: true,
      fieldInputNameMarketoRestApi: 'toastType',
      fieldType: 'Select (Dropdown)',
      fieldOptions: [
        {
          key: "I'd like a restaurant consultation",
          value: "I'm interested in restaurant technology"
        },
        {
          key: "I'm already a Toast customer",
          value: "I'm a Toast customer looking for help"
        },
        {
          key: "I'm a restaurant guest",
          value: "I'm a restaurant guest looking for help"
        }
      ],
      fieldDependentId: '',
      __typename: 'ContentfulMdsFormField'
    })
    fields.push({
      marketoFieldName: 'optIn',
      fieldLabel:
        'Toast may send me additional communications to offer Toast products and services, including via SMS message. I can revoke my consent at any time.',
      isRequired: false,
      fieldInputNameMarketoRestApi: 'optIn',
      fieldType: 'Checkbox (Single/Multi Select)',
      fieldDependentId: '',
      __typename: 'ContentfulMdsFormField'
    })
  }
  const steps = [] as any
  steps.push({ coreFields: fields })

  const fieldIdPrefix = 'POSDemo-' + region
  const rightImage = imagePosition === 'right'
  const sectionClasses = classNames(cssClasses)
  const contentClasses = classNames('col-span-6 items-center grid gap-0', {
    'order-1 [@media(min-width:992px)]:order-2 [@media(min-width:992px)]:-ml-[2.25rem]':
      rightImage,
    // Left image position classes
    'order-1 [@media(min-width:992px)]:order-2 [@media(min-width:992px)]:-mr-[2.25rem]':
      !rightImage
  })
  const imgClasses = classNames(
    '[@media(max-width:991px)]:w-full [@media(min-width:992px)]:max-w-none',
    {
      '[@media(min-width:992px)]:pl-4 [@media(min-width:992px)]:-mr-12':
        rightImage,
      '[@media(min-width:992px)]:-ml-12': !rightImage,
      '[@media(min-width:1400px)]:w-[114%] [@media(min-width:992px)]:ml-[-83px] [@media(min-width:992px)]:pt-[100px] [@media(min-width:1400px)]:ml-[-100px] [@media(min-width:1400px)]:pt-[95px] [@media(max-width:1399px)]:!max-w-full':
        region !== 'US'
    }
  )
  const formClasses = classNames('col-span-6 ', {
    '[@media(min-width:992px)]:pr-24 order-1': rightImage,
    '[@media(min-width:992px)]:pl-24 order-1 [@media(min-width:992px)]:order-2':
      !rightImage,
    'pb-24 md:pb-[7.5rem] [@media(max-width:991px)]:pt-[2.5rem]':
      region === 'US',
    'pb-0 md:pb-[2rem]': region !== 'US'
  })
  const imgContainerClasses = classNames({
    '[@media(min-width:992px)]:min-h-[520px] [@media(min-width:992px)]:min-w-[490px] [@media(min-width:992px)_or_(max-width:767px)]:bg-[#ff4c00] [@media(min-width:992px)_or_(max-width:767px)]:rounded-[10px] [@media(min-width:1400px)]:h-[98%] [@media(min-width:1400px)]:w-[108%] [@media(max-width:767px)]:bg-contain [@media(min-width:992px)_or_(max-width:767px)]:bg-schedule-demo-illustration [@media(min-width:992px)]:bg-[length:70%] [@media(min-width:992px)_or_(max-width:767px)]:bg-no-repeat [@media(min-width:1400px)]:mt-[60px]':
      variation === 'brand'
  })
  const wrapperClasses = classNames({
    '[@media(min-width:992px)]:pt-[120px]': region === 'US'
  })

  return (
    <>
      <section
        className={sectionClasses}
        data-testid='POSFiftyDemoForm'
        data-tracking-section={scrollTrackingSectionName}
        id={uniqueId}
      >
        <div
          className={`${wrapperClasses} ds-wrapper pt-5 [@media(min-width:786px)]:pt-10`}
        >
          <div className='ds-container grid grid-cols-6 items-center [@media(min-width:992px)]:grid-cols-12 !px-4 gap-y-0 items-start'>
            <div className={contentClasses}>
              <div className={imgContainerClasses}>
                <div>
                  {imageResolutions ? (
                    <ImageResolutions
                      classes={imgClasses}
                      images={{ imageResolutions }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <div className={formClasses}>
              <MainForm
                componentContext='ContentfulMdsShowcaseForm'
                description={description}
                disclaimer='disclaimer'
                entryId=''
                fieldIdPrefix={fieldIdPrefix}
                formCookie='toastDemoFormPOS'
                formSteps={steps}
                heading={heading}
                heapInteractionSubmit='hpbottomdemo_submit'
                marketoId={region === 'US' ? '1003' : '1235'}
                region={region}
                submitLabel='Get a Demo'
                marketoProgramName={
                  region !== 'US'
                    ? region + '-Website-Demo-Request'
                    : 'Website-Demo-Request'
                }
                thankYouPageURL={
                  region !== 'US'
                    ? '/' + region.toLowerCase() + '/request-demo-confirmed'
                    : '/request-demo-confirmed'
                }
              />
            </div>
          </div>
        </div>
      </section>
      {region === 'US' && (
        <section className='bg-gray-0'>
          <div
            dangerouslySetInnerHTML={{ __html: privacyStatement }}
            className='text-[#252525] w-full mx-auto px-[15px] py-[26.6666666667px] md:py-[40px]
              max-w-[1196px] !text-[0.75rem]'
          />
        </section>
      )}
    </>
  )
}

export default FiftyDemoForm
